var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserManagementActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 15.5V14.1667C13 13.4594 12.6839 12.7811 12.1213 12.281C11.5587 11.781 10.7956 11.5 10 11.5H4C3.20435 11.5 2.44129 11.781 1.87868 12.281C1.31607 12.7811 1 13.4594 1 14.1667V15.5",
    stroke: "#5921F2",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 8.5C8.65685 8.5 10 7.15685 10 5.5C10 3.84315 8.65685 2.5 7 2.5C5.34315 2.5 4 3.84315 4 5.5C4 7.15685 5.34315 8.5 7 8.5Z",
    stroke: "#5921F2",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17 15.5V14.1371C16.9996 13.5332 16.8029 12.9465 16.4409 12.4692C16.0789 11.9919 15.5721 11.651 15 11.5",
    stroke: "#5921F2",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 2.5C12.5721 2.67056 13.0792 3.05796 13.4413 3.60114C13.8034 4.14432 14 4.81238 14 5.5C14 6.18762 13.8034 6.85567 13.4413 7.39886C13.0792 7.94204 12.5721 8.32944 12 8.5",
    stroke: "#5921F2",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserManagementActive);
export default __webpack_public_path__ + "static/media/UserManagementActive.1471512a5961a9fa29c0f71d3700b79c.svg";
export { ForwardRef as ReactComponent };